import { render } from "./EmailPreviewPanelContent.vue?vue&type=template&id=5d80821e&scoped=true"
import script from "./EmailPreviewPanelContent.vue?vue&type=script&lang=js"
export * from "./EmailPreviewPanelContent.vue?vue&type=script&lang=js"

import "./EmailPreviewPanelContent.vue?vue&type=style&index=0&id=5d80821e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d80821e"]])

export default __exports__